import axios from 'axios';

let instance = null;

export default class HttpRequestHandler {
  constructor() {
    if (instance) {
      return instance;
    }

    instance = axios.create({
      baseURL: window.location.origin,
      headers: {}
    });

    instance.interceptors.request.use(
      config => {
        if (config.headers.common && !config.headers.common['session-id']) {
          HttpRequestHandler.setSessionId(sessionStorage.getItem('sessionId'));
        }
        return config;
      },
      null,
      { synchronous: true }
    );

    instance.interceptors.response.use(
      response => response.data,
      error => Promise.reject(error)
    );

    return instance;
  }

  static setSessionId(sessionId) {
    if (sessionId) {
      instance.defaults.headers.common['session-id'] = sessionId;
      sessionStorage.setItem('sessionId', sessionId);
    }
  }

  static removeSessionId() {
    sessionStorage.removeItem('sessionId');
  }
}
